import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[appTrim]'
})
export class TrimDirective {

  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef, private control: NgControl) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('blur')
  onBlur() {
    this.el.value = this.el.value.trim();
    if (typeof(this.control.control.value) == 'string') {
      this.control.control.setValue(this.el.value);
      this.control.control.updateValueAndValidity();
    }
  }

}
